module.exports = __webpack_public_path__ + "static/img/honor11.9af203b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/honor/honor11.png
// module id = wctb
// module chunks = 0